import { Component, JSXElement, Show } from 'solid-js';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';
import SwitchButton from '../SwitchButton/SwitchButton';
import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';

export enum ToggleType {
  CheckBox = 'checkbox',
  RadioButton = 'radio',
  ToggleButton = 'toggle',
}

export interface CustomToggleProps {
  type?: ToggleType;
  tooltip?: string;
  className?: string;
  isChecked?: boolean;
  disabled?: boolean;
  onChanged?(isChecked: boolean): void;
  children?: JSXElement;
  'data-cy'?: string;
}

const CustomToggle: Component<CustomToggleProps> = (props): JSXElement => {
  return (
    <span
      class={`custom-toggle ${props.className ?? ''} ${props.disabled ? 'disabled' : ''}`}
      data-tip={props.tooltip}
      data-testid={props['data-cy'] || 'custom-toggle'}
      style={{ display: 'inline-flex', 'align-items': 'center', gap: '4px' }}
    >
      <Show when={props.type === ToggleType.CheckBox}>
        <CustomCheckbox
          name="custom-toggle-checkbox"
          value="checked"
          checked={props.isChecked}
          disabled={props.disabled}
          onChange={() => props.onChanged?.(!props.isChecked)}
        />
      </Show>

      <Show when={props.type === ToggleType.ToggleButton}>
        <SwitchButton
          name="custom-toggle-switch"
          isChecked={props.isChecked}
          disabled={props.disabled}
          onChange={(checked) => props.onChanged?.(checked)}
        />
      </Show>

      <Show when={props.type === ToggleType.RadioButton}>
        <CustomRadioButton
          name="custom-toggle-radio"
          value="selected"
          checked={props.isChecked}
          disabled={props.disabled}
          onChange={() => props.onChanged?.(!props.isChecked)}
        />
      </Show>

      <Show when={props.children}>
        <span
          class="content"
          onClick={() => !props.disabled && props.onChanged?.(!props.isChecked)}
          style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
        >
          {props.children}
        </span>
      </Show>
    </span>
  );
};

export default CustomToggle;
